import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IIncidentAlertsState {
  unviewedCount: number;
  // Bumped to ask the app-wide listener to re-count (e.g. after a delete)
  countRefreshRequest: number;
}

const initialState: IIncidentAlertsState = {
  unviewedCount: 0,
  countRefreshRequest: 0,
};

const incidentAlertsSlice = createSlice({
  name: "incidentAlerts",
  initialState,
  reducers: {
    setUnviewedCount: (state, action: PayloadAction<number>) => {
      state.unviewedCount = Math.max(0, action.payload);
    },
    requestCountRefresh: (state) => {
      state.countRefreshRequest += 1;
    },
  },
});

export default incidentAlertsSlice;
